/** Shared field helpers aligned with extranet criminal wizard. */
export function FieldError({ message }: { message?: string }) {
  return (
    <div className={`field-err${message ? ' on' : ''}`} role="alert">
      {message ?? ''}
    </div>
  );
}

export function inpClass(hasError: boolean): string {
  return `ccr-inp${hasError ? ' inv' : ''}`;
}
